import type { UserSettingsIdentifier } from '@/types/userSettingsApiTypes';

export const USER_SETTINGS_CACHE_KEY = 'user-settings';

export const USER_SETTINGS_IDENTIFIERS = {
  CLIENT_DASHBOARD: 'CLIENT_DASHBOARD',
  CALENDAR_VISIBILITY_TOOGLES: 'CALENDAR_VISIBILITY_TOOGLES',
  HOME_DASHBOARD: 'HOME_DASHBOARD',
} as const satisfies Record<string, UserSettingsIdentifier>;

export function getUserSettingsQueryKey(identifier?: UserSettingsIdentifier | null) {
  return [USER_SETTINGS_CACHE_KEY, identifier ?? null] as const;
}
